import { Flex } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import PageHeader from "../../components/PageHeader";
import { useParams } from "react-router";
import RegistrationDetails from "./registrationdetails.registration";
import { WorkspaceCheckerHide } from "../../components/WorkspaceChecker";
import ExportCSV from "../../components/ExportCSV";
import { ENDPOINTS } from "../../constants/endpoints.constant";

const Registration = () => {
  const event = useSelector((state: RootState) => state.event);
  const { id: routeEventId } = useParams();
  const eventId = routeEventId ?? event.id;

  return (
    <div className="p-[24px]">
      <Flex justify="space-between" wrap align="center" className="!mb-[20px]">
        <PageHeader
          title="Registrations"
          description="All the tickets sold in a single place"
          backBtn={false}
          bottomMargin={false}
        />
        <Flex gap={20} align="center" className=" w-full md:w-auto">
          <>
            <WorkspaceCheckerHide showOnCompleted={true}>
              <div className="hidden md:block">
                <ExportCSV
                  endpoint={ENDPOINTS.get_registration}
                  queryParams={`filter[order.event_id][eq]=${eventId}&event_id=${eventId}`}
                />
              </div>
            </WorkspaceCheckerHide>
          </>
        </Flex>
      </Flex>
      <WorkspaceCheckerHide showOnCompleted={true}>
        <Flex justify="flex-end" className="block md:!hidden !mb-[20px]">
          <ExportCSV
            endpoint={ENDPOINTS.get_registration}
            queryParams={`filter[order.event_id][eq]=${eventId}&event_id=${eventId}`}
          />
        </Flex>
      </WorkspaceCheckerHide>
      <Flex wrap="wrap" gap={16} justify="start" className="w-full">
        <RegistrationDetails id={eventId!} />
      </Flex>
    </div>
  );
};

export default Registration;
